export default "__VITE_ASSET__670ef4c7__"